export default "__VITE_ASSET__d17c182b__"